import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./Components/MainLayout/MainLayout";
import Dashboard from "./Components/Dashboard/Dashboard";
import Platforms from "./Components/Platforms/Platforms.js";
import PlatformDetails from "./Components/Platforms/PlatformDetails/PlatformDetails";
import Subscriptions from "./Components/Subscriptions/Subscriptions"; // Importe a nova página
import SubscriptionDetails from "./Components/Subscriptions/SubscriptionDetails/SubscriptionDetails"; // Importe a nova página
import Login from "./Components/Login/Login";
import { AuthProvider, useAuth } from "./Context/AuthContext";
import { Toaster } from "react-hot-toast";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function AppRoutes() {
  const { isLoggedIn } = useAuth();
  return (
    <div
      style={{
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        minHeight: "100vh",
        backgroundColor: "#0D1117",
      }}
    >
      <Toaster
        position="top-right"
        toastOptions={{
          success: {
            style: {
              background: "#238636",
              color: "white",
            },
          },
          error: {
            style: {
              background: "#DA3633",
              color: "white",
            },
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigate to="/dashboard" />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/platforms"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Platforms />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/platforms/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <PlatformDetails />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* ROTAS DE ASSINATURAS ADICIONADAS */}
        <Route
          path="/subscriptions"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Subscriptions />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscriptions/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SubscriptionDetails />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={<Navigate to={isLoggedIn ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;